import { GlobalSearchValueMatchInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/GlobalSearch/GlobalSearch.Controller.ts
export class GlobalSearchAPI {
  static async searchValues(orgId: number, query: string): Promise<GlobalSearchValueMatchInterface[]> {
    return APIService.Server.get<GlobalSearchValueMatchInterface[]>(`/global-search/org/${orgId}/values`, { query });
  }
}
